var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "full_wrap", attrs: { id: "wrap" } }, [
      _c("div", { attrs: { id: "container" } }, [
        _c("div", { staticClass: "container_wrap" }, [
          _c("div", { staticClass: "msg_item" }, [
            _c("p", [
              _c("em", [
                _vm._v("Session has expired."),
                _c("br"),
                _vm._v("Please login try again.")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ed9a8de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed9a8de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/NoSessionPage.vue
// module id = uG4s
// module chunks = 0